import React from 'react';

const fieldTypeGroups = [
  {
    label: 'Title, text, etc.',
    types: [
      {label: 'Title', value: 'TITLE'},
      {label: 'Subtitle', value: 'SUBTITLE'},
      {label: 'Paragraph', value: 'PARAGRAPH'},
      {label: 'Divider', value: 'DIVIDER'},
    ],
  },
  {
    label: 'Form fields',
    types: [
      {label: 'Single-line text field', value: 'TEXT_FIELD'},
      {label: 'Email field', value: 'EMAIL'},
      {label: 'Multi-line text field', value: 'TEXT_AREA'},
      {label: 'Number', value: 'NUMBER'},
      {label: 'Phone number', value: 'PHONE_NUMBER'},
      {label: 'Promotional code', value: 'PROMO_CODE'},
      {label: 'Checkbox', value: 'CHECKBOX'},
      {label: 'Radio', value: 'RADIO'},
      {label: 'Dropdown', value: 'DROPDOWN'},
      {label: 'Date', value: 'DATE'},
      {label: 'Color', value: 'COLOR'},
      {label: 'File upload', value: 'FILE'},
      {label: 'Hidden', value: 'HIDDEN'},
    ],
  },
];

export default class FieldType extends React.Component {

  constructor(props) {
    super(props);
    let value = props.value;
    if (!value) {
      value = 'TEXT_FIELD';
      props.onChange(value);
    }
    this.state = {
      value: value,
      usedInCondition: props.usedInCondition,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {usedInCondition: nextProps.usedInCondition};
  }

  render() {
    return <div className="mb-3">
      <label htmlFor={this.props.id + 'FieldType'} className="form-label">Type</label>
      <select id={this.props.id + 'FieldType'}
              className="form-select"
              value={this.state.value || ''}
              onChange={e => this.setState(
                {value: e.target.value},
                () => this.props.onChange(this.state.value)
              )}
              disabled={this.state.usedInCondition}>
        {fieldTypeGroups.map((group, i) =>
          <optgroup key={i} label={group.label}>
            {group.types.map(type => <option key={type.value} value={type.value}>
              {type.label}
            </option>)}
          </optgroup>
        )}
      </select>
      {this.state.usedInCondition &&
      <div className="form-text">This field is used in a condition, its type cannot be modified</div>
      }
    </div>;
  }

}
